import { BugFilled, BugRegular, FoodCakeFilled, FoodCakeRegular, LightbulbFilled, LightbulbRegular, bundleIcon } from "@fluentui/react-icons";

import { FeedbackCategory } from "./UserFeedback.types";

const BugIcon = bundleIcon(BugFilled, BugRegular);
const ComplimentIcon = bundleIcon(FoodCakeFilled, FoodCakeRegular);
const FeatureIcon = bundleIcon(LightbulbFilled, LightbulbRegular);

export const feedbackDeviceLabel = {
    Desktop: "Desktop",
    Mobile: "Mobile"
} as const;

export const feedbackCategoryItems = [
    {
        category: FeedbackCategory.ReportProblem,
        icon: BugIcon,
        label: FeedbackCategory.ReportProblem
    },
    {
        category: FeedbackCategory.GiveCompliment,
        icon: ComplimentIcon,
        label: FeedbackCategory.GiveCompliment
    },
    {
        category: FeedbackCategory.SuggestFeature,
        icon: FeatureIcon,
        label: FeedbackCategory.SuggestFeature
    }
];
